import { brokerRegistration as initialState } from '../initialState.tsx';
import {
  REQUEST_USER_REGISTRATION,
  RECEIVE_USER_REGISTRATION,
  ERROR_USER_REGISTRATION,
  REQUEST_AVAILABLE_COMPANIES,
  RECEIVE_AVAILABLE_COMPANIES,
  ERROR_AVAILABLE_COMPANIES

} from 'typeConstants';

const brokerRegistration = (state = initialState, action) => {

  switch (action.type) {
    case REQUEST_USER_REGISTRATION:
      return {
        ...state,
        isSubmitting: true
      };
    case RECEIVE_USER_REGISTRATION:
      return {
        ...state,
        isSubmitting: false,
        success: action.payload.success,
        username: action.payload.username
      };
    case ERROR_USER_REGISTRATION:
      return {
        ...state,
        isSubmitting: false
      };
    case REQUEST_AVAILABLE_COMPANIES:
      return {
        ...state,
        isFetchingCompanies: true
      };
    case RECEIVE_AVAILABLE_COMPANIES:
      return {
        ...state,
        availableCompanies: action.payload,
        isFetchingCompanies: false
      };
    case ERROR_AVAILABLE_COMPANIES:
      return {
        ...state,
        isFetchingCompanies: false
      };
    default:
      return state;
  }
};

export default brokerRegistration;
